export default {
  name: 'eventsLog',
  list: 'list',
  meta: 'meta',
  query: 'query',
  filters: 'filters',
  fetchId: 'fetchId'
};
